import React from 'react';

const AdminTest = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-foreground mb-4">
          Admin Test Page
        </h1>
        <p className="text-muted-foreground">
          If you can see this, the routing is working correctly!
        </p>
        <div className="mt-8">
          <a 
            href="/admin" 
            className="bg-primary text-primary-foreground px-6 py-3 rounded-lg hover:bg-primary/90 transition-colors"
          >
            Go to Admin Panel
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminTest;
